import React from "react";
import "./IconButton.css";

const IconButton = React.forwardRef(function IconButton(
    { icon: Icon, label, size = "md", tone = "default", className = "", disabled, ...rest },
    ref
) {
    const dim = size === "sm" ? 14 : 16;
    return (
        <button
            ref={ref}
            type="button"
            className={`icon-btn icon-btn--${size} icon-btn--${tone} focus-ring ${className}`}
            aria-label={label}
            title={label}
            disabled={disabled}
            {...rest}
        >
            <Icon size={dim} aria-hidden="true" />
        </button>
    );
});

export default IconButton;
